import { Box } from "@mui/system";
import ClickImpressionTabs from "./ClickImpressionContent/ClickImpressionTabs";

const ClickImpression = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <ClickImpressionTabs />
      </Box>
    </>
  );
};

export default ClickImpression;
